import { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import useSeo from '@/hooks/useSeo';
import { faqItems } from '@/mocks/faq';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: { '@type': 'Answer', text: item.a },
  })),
};

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  useSeo({
    title: '常见问题 - 洞洞杂货铺漫画新手入门问答',
    description: '关于洞洞杂货铺漫画是什么、洞洞含义、世界观设定、阅读顺序等常见问题汇总，帮你快速理解这部漫画。',
    keywords: '洞洞杂货铺漫画,洞洞杂货铺漫画是什么,洞洞杂货铺洞洞含义,洞洞杂货铺世界观',
    ogType: 'website',
    jsonLd,
  });

  return (
    <Layout>
      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-16">
          <nav aria-label="面包屑" className="text-sm text-foreground-500">
            <Link to="/" className="transition-colors hover:text-primary-700">首页</Link>
            <span className="mx-2 text-foreground-300">/</span>
            <span className="text-foreground-700">常见问题</span>
          </nav>
          <h1 className="mt-4 text-2xl leading-relaxed text-foreground-950 md:text-3xl">常见问题</h1>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-foreground-600">
            关于《洞洞杂货铺》漫画最常见的问题与解答，涵盖类型、洞洞含义、世界观、阅读顺序等方方面面。
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-4 py-12 md:px-6">
        <div className="space-y-4">
          {faqItems.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                  open ? 'border-primary-200' : 'border-background-200'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : index)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="flex items-start gap-3 text-base font-semibold text-foreground-950">
                    <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-accent-500 text-xs text-background-50">Q</span>
                    {item.q}
                  </span>
                  <i
                    className={`${open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-xl text-foreground-500 transition-transform`}
                    aria-hidden="true"
                  ></i>
                </button>
                {open && (
                  <div className="px-5 pb-5 pl-14">
                    <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-10 rounded-lg border border-background-200 bg-background-100 p-6 text-center">
          <h2 className="text-lg text-foreground-950">仍有疑问？</h2>
          <p className="mt-2 text-sm text-foreground-600">去看看更完整的设定文章，或许能找到答案。</p>
          <Link
            to="/lore"
            className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            浏览全部设定
            <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </Layout>
  );
}